import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { keyframes } from "@mui/system";

const bounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); }
  30% { transform: translateY(-4px); }
`;

function Dot({ delay }) {
  return (
    <Box
      sx={{
        width: 6,
        height: 6,
        borderRadius: "50%",
        bgcolor: "text.disabled",
        animation: `${bounce} 1.2s infinite`,
        animationDelay: `${delay}s`,
      }}
    />
  );
}

export default function TypingIndicator() {
  return (
    <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
      <Avatar
        src="/images/susie-avatar.png"
        alt="Susie"
        sx={{ width: 56, height: 56, bgcolor: "secondary.main", fontSize: 18 }}
      >
        🐢
      </Avatar>
      <Box
        sx={{
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          borderRadius: "12px 12px 12px 2px",
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <Dot delay={0} />
        <Dot delay={0.2} />
        <Dot delay={0.4} />
      </Box>
    </Box>
  );
}
